import React from "react";
import Portfolio from "../portfolio/portfolio";
import Footer from "../footer/footer";
import "./music.scss";

class Music extends React.Component {
  render() {
    return (
      <div className="music-page">
        <Portfolio />
        <Footer />
      </div>
    );
  }
}

export default Music;

